<template>
  <div class="w-75">
    <h1>Krankheit Hinzufügen</h1>
    <div class="row">
      <div class="col-8">
        <span v-if="errorMessage" class="text-danger ms-2 ml-1">
          {{ errorMessage }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <div class="form-group">
          <div v-if="adminAccess">
            <label class="control-label">Employee Name</label>
            <div >
              <select v-if="employeesLoaded" v-model="empId" class="form-control">
                <option v-for="employee in employees" v-bind:value="employee.id" :key="employee.id">
                  {{ employee.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="form-group">
          <label class="control-label col-md-4">Beschreibung</label>
          <div >
            <textarea v-model="description" class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <div class="text-wrap form-group d-flex align-items-center">
          <input type="checkbox" v-model="digitalSickNote" id="digitalSickNoteCheckbox" class="me-2">
          <label for="digitalSickNoteCheckbox" class="ml-2 mb-0">Digital sick note </label>
          <span v-if="digitalSickNote" class="text-info ms-2 ml-1">
            (I hereby confirm that I was signed off sick by a doctor.)
          </span>
        </div>
      </div>

      <div class="col-8">
        <div class="form-group">
          <label class="control-label col-md-4">AU</label>
          <div>
            <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" :disabled="digitalSickNote"
              class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-8">
        <div class="form-group">
          <label class="control-label">Von</label>
          <div >
            <datepicker v-model="from" class="text-box single-line" />
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-8">
        <div class="form-group">
          <label class="control-label">Bis</label>
          <div >
            <datepicker v-model="to" class="text-box single-line" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <a class="btn btn-success" @click="saveChanges">Speichern</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import moment from "moment";
import datepicker from "vuejs-datepicker";


export default {
  components: {
    datepicker
  },
  name: "illnessCreate",
  data: function () {
    return {
      minimumLeaveDate: moment().subtract(30, 'd'),
      employees: [],
      employeesLoaded: false,
      file: '',
      description: '',
      userId: "OverwrittenByBackend",
      from: moment().toString(),
      to: moment().toString(),
      digitalSickNote: false,
      errorMessage: "",
      empId: "",
    }
  },
  created: function () {
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    saveChanges: function (event) {
      this.errorMessage = ""; // Reset the error message

      if (!this.digitalSickNote && !this.file) {
        this.errorMessage = "Please attach the sick note. Alternatively, if a digital sick note is applicable, select the option.";
        return;
      }

      let formData = new FormData();
      formData.set('empId', this.empId);
      formData.set('from', moment(this.from).format('yyyy-MM-DD'));
      formData.set('to', moment(this.to).format('yyyy-MM-DD'));
      formData.set('description', this.description);
      formData.append('file', this.file);
      formData.set('DigitalSickNote', this.digitalSickNote);

      //Send to server
      axios.post(process.env.VUE_APP_API_PATH + "illnesses",
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(result => {
        //Changes have been saved
        this.$router.push("/illnesses");
      }, error => {
        //Changes have not been saved
        this.errorMessage = error.response.data;
        console.error(error);
      });
    },
    loadComponentData: function () {
      // Load Employees
      axios({
        method: "GET",
        url: process.env.VUE_APP_API_PATH + "user/get",
      }).then(
        (result) => {
          this.employees = result.data.filter(d => (!d.leaveDate || d.leaveDate < this.minimumLeaveDate))
          this.employeesLoaded = true;
        },
        (error) => {
          this.employeesLoaded = false;
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus", "getProfile"]),
    ...mapState({
      adminAccess: state => state.user.profile.adminAccess,
    }),
  },
  mounted() {
    this.loadComponentData();
  }
};
</script>
